import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { UserFacade } from '@library/store/user/user.facade';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';
import { PinType } from '@store/weathermap.store';

@Component({
  selector: 'app-legend',
  imports: [
    TextModule,
    DirectivesModule,
    CommonModule,
    PipesModule,
  ],
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('closed', style({
        transform: 'translateY(calc(100% + 30px))',
        opacity: 0,
      })),
      state('opened', style({
        transform: 'translateY(0)',
        opacity: 1,
      })),
      transition('closed <=> opened', animate('150ms ease-in-out')),
    ]),
  ],
})
export class LegendComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);
  private readonly userFacade = inject(UserFacade);

  PinType = PinType;
  EnumMeasureTypes = EnumMeasureTypes;

  selectedPintype = this.weathermapFacade.selectedPintype;
  unitSystem = this.weathermapFacade.unitSystem;
  windUnit = this.weathermapFacade.windUnit;

  currentUser$ = this.userFacade.currentUser$;

  // Todo use Enums constants
  temperatureScale = {
    0: [-30, -15, 5, 15, 30, 40, 50],
    1: [-22, 5, 41, 59, 86, 104, 122],
  };

  rainScale = {
    top: ['app.__RAIN_SCALE_1', 'app.__RAIN_SCALE_3', 'app.__RAIN_SCALE_5'],
    bottom: ['app.__RAIN_SCALE_0', 'app.__RAIN_SCALE_2', 'app.__RAIN_SCALE_4', 'app.__RAIN_SCALE_6'],
  };

  // Todo use Enums constants
  windScale = {
    0: [0, 5, 11, 19, 28, 38, 49, 61, 74, 88, 102, 117],
    1: [0, 3, 7, 12, 17, 24, 30, 38, 46, 55, 63, 73],
    2: [0, 1, 3, 5, 8, 11, 14, 17, 21, 24, 28, 32],
    3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    4: [0, 3, 6, 10, 15, 21, 26, 33, 40, 48, 55, 63],
  };

  selectedStation = this.weathermapFacade.selectedStation;

  state: 'opened' | 'closed';
  @HostBinding('@slideInOut') get slideInOut(): string {
    return this.selectedStation() ? 'closed' : 'opened';
  }
}
